module.exports = __webpack_public_path__ + "static/media/DSC_0030.f11d9046.jpg";